import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";

import { appLayoutRoute } from "../../router/rootRoutes";

/**
 * Mode and anchor date live in the URL so a calendar view is shareable and
 * survives a reload.
 *
 * Both degrade to `undefined` rather than rejecting. A shared link that has
 * outlived a rename, or a hand-edited date, should open the calendar on its
 * defaults -- turning a stale URL into a full error boundary punishes the
 * reader for something they did not do. The page re-checks both values anyway.
 */
const calendarSearchSchema = z.object({
  mode: z.enum(["agenda", "week", "month"]).optional().catch(undefined),
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/u)
    .optional()
    .catch(undefined),
  /** Network filter, in the URL so a filtered calendar is shareable too. */
  network: z.string().min(1).max(80).optional().catch(undefined),
});

export const calendarRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/calendar",
  validateSearch: calendarSearchSchema,
  component: lazyRouteComponent(() => import("./CalendarPage"), "CalendarPage"),
});

export const calendarRoutes = [calendarRoute] as const;
